export default __webpack_public_path__ + "static/media/wiz-1.9f68ff78.svg";